"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TabNavConfig = /** @class */ (function () {
    function TabNavConfig(json) {
        this.json = json;
    }
    TabNavConfig.prototype.getTabs = function () {
        return this.json.tabs;
    };
    return TabNavConfig;
}());
exports.default = TabNavConfig;
